import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import Accesories from './Accesories';
import registerServiceWorker from './registerServiceWorker';
import 'react-app-polyfill/ie11';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
